import React from 'react';
import {useTranslation} from 'next-i18next';

interface IProps {
    handleOpenLoginForm: () => void;
}

const LoginFormSwitcher: React.FC<IProps> = ({handleOpenLoginForm}) => {
    const {t} = useTranslation('common');

    return (
        <>
            <div className="relative mb-6 mt-8 flex flex-col items-center justify-center text-sm text-heading sm:mb-8 sm:mt-11">
                <hr className="w-full" />
                <span className="absolute -top-2.5 bg-primary-0 px-2 ltr:left-2/4 ltr:-ml-4 rtl:right-2/4 rtl:-mr-4">
                    {t('text-or')}
                </span>
            </div>
            <div className="text-center text-sm text-body sm:text-base">
                {t('text-already-account')}{' '}
                <button
                    aria-label="Đăng nhập"
                    onClick={handleOpenLoginForm}
                    className="font-semibold text-accent underline transition-colors duration-200 hover:text-blue-kid! hover:no-underline focus:text-accent-hover focus:no-underline focus:outline-none ltr:ml-1 rtl:mr-1">
                    {t('text-login', 'Đăng nhập')}
                </button>
            </div>
        </>
    );
};

export default LoginFormSwitcher;
